import { createContext } from "react"
import React from "react"
import { EstabelecimentosAplicativoInicial } from "../models/estabelecimentosAplicativoModel"
import type { EstabelecimentosAplicativoModel } from "../models/estabelecimentosAplicativoModel"
import type { EstabelecimentosAplicativoActionModel } from "./estabelecimentosAplicativoActions"
import type {
    EstabelecimentoCriado,
    NovoEstabelecimentoPayload,
} from "../../../services/estabelecimentosAplicativo"

type EstabelecimentosAplicativoContextProps = {
    dados: EstabelecimentosAplicativoModel
    dispatch: React.Dispatch<EstabelecimentosAplicativoActionModel>
    adicionar: (idEstabelecimento: number) => Promise<void>
    desassociar: (idEstabelecimento: number) => Promise<void>
    criarNovo: (payload: NovoEstabelecimentoPayload) => Promise<EstabelecimentoCriado>
    erroCarregamento: string | null
}

const initialContextValue: EstabelecimentosAplicativoContextProps = {
    dados: EstabelecimentosAplicativoInicial,
    dispatch: () => {},
    adicionar: async () => {},
    desassociar: async () => {},
    criarNovo: async () => {
        throw new Error("Contexto de estabelecimentos não inicializado")
    },
    erroCarregamento: null,
}

export const EstabelecimentosAplicativoContext =
    createContext<EstabelecimentosAplicativoContextProps>(initialContextValue)
